import type { FC } from 'react';
import type { Showable } from 'utils/hooks/useShowable';
import { omit } from 'utils/object/omit';
import { CustomPortSettingsDialog } from './CustomPortSettingsDialog';
import type { CustomPortSetting, CustomPortSettingIndexed } from './model';
import type { CustomPortSettingsCommands } from './useCustomPortSettings';

export type EditSettingPayload = {
  setting: CustomPortSettingIndexed;
};

type Props = {
  commands: CustomPortSettingsCommands;
  showable: Showable<EditSettingPayload>;
};

export const EditSettingDialog: FC<Props> = (props) => {
  if (!props.showable.shown) {
    return null;
  }

  const { showable } = props;

  return (
    <CustomPortSettingsDialog
      initialValues={omit(['index'], showable.payload.setting)}
      onClose={showable.hide}
      onSubmit={(values: CustomPortSetting) => {
        props.commands.editSetting({
          setting: values,
          index: showable.payload.setting.index,
        });
      }}
      type='edit'
    />
  );
};
